import { FaEraser } from "react-icons/fa";
import { AppButton } from "../../_CORE/APP/Templates/_UI/Button/_index";
import "./_Styles/AdvancedFilterPanel.css";

export const onNormalizeDate = (value) => {
    if (!value) return null;
    const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const onSameDay = (left, right) => {
    const a = onNormalizeDate(left);
    const b = onNormalizeDate(right);
    if (!a || !b) return false;
    return a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate();
};

export const onDateMatches = (value, range = [null, null], exact = null) => {
    if (exact && !onSameDay(value, exact)) return false;
    const [from, to] = Array.isArray(range) ? range : [null, null];
    if (!from && !to) return true;
    const date = onNormalizeDate(value);
    if (!date) return false;
    const time = date.getTime();
    if (from) {
        const start = onNormalizeDate(from);
        if (start) {
            start.setHours(0, 0, 0, 0);
            if (time < start.getTime()) return false;
        }
    }
    if (to) {
        const end = onNormalizeDate(to);
        if (end) {
            end.setHours(23, 59, 59, 999);
            if (time > end.getTime()) return false;
        }
    }
    return true;
};

export const AdvancedFilterPanel = ({
    isOpen,
    children,
    onClear = null,
    activeCount = 0,
    className = "",
}) => {
    if (!isOpen) return null;
    return <div className={`LStudio__advanced_filter_panel ${className}`.trim()}>
        <div className="LStudio__advanced_filter_panel_grid">{children}</div>
        {onClear && Number(activeCount || 0) > 0 && <div className="LStudio__advanced_filter_panel_footer">
            <AppButton size="sm" variant="ghost" tone="neutral" icon={<FaEraser />} onClick={onClear}>
                Limpiar avanzados
            </AppButton>
        </div>}
    </div>;
};
